var LayoutType = /*#__PURE__*/function (LayoutType) {
  LayoutType[LayoutType["Default"] = 0] = "Default";
  LayoutType[LayoutType["Saved"] = 1] = "Saved";
  LayoutType[LayoutType["Custom"] = 2] = "Custom";
  LayoutType[LayoutType["Predefined"] = 3] = "Predefined";
  return LayoutType;
}({});

export { LayoutType };
//# sourceMappingURL=layouts.esm.js.map
